const BASE_URL = process.env.NODE_ENV === 'production' ?
  process.env.REACT_APP_BASE_URL_PRODUCTION :
  process.env.REACT_APP_BASE_URL;

export default BASE_URL;


// WEBPACK FOOTER //
// ./src/helpers/base-url.js